import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { CreateMoneyTransactionPayload } from "../../payload/CreateMoneyTransaction/CreateMoneyTransactionPayload";

const createMoneyTransactionFetch = (state: FinanceState, action: PayloadAction<CreateMoneyTransactionPayload>) => {
    state.isLoading = true;
}

export default createMoneyTransactionFetch;